import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactory,
  ComponentFactoryResolver,
  Type,
  ComponentRef
} from '@angular/core';
import { ModalService, ModalConfig } from "@services/modal";

@Component({
  selector: 'modal',
  template: `
    <div class="modal">
      <div class="m__content-wrapper" [ngClass]="{ 'is-visible': isVisible }">
        <div class="m__white-wash"></div>
        <div class="m__modal">
          <div #placeholder></div>
          <div class="m__close" (click)="closeModal()">&times;</div>
        </div>
      </div>
    </div>
  `,
})
export class ModalComponent implements OnInit {

  @ViewChild('placeholder', { read: ViewContainerRef }) placeholderVcr: ViewContainerRef;

  isVisible: boolean;

  constructor(
    private modalService: ModalService,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  ngOnInit() {
    this.susbcribeToComponents();
  }

  susbcribeToComponents() {
    this.modalService.component$.subscribe(
      (modalInputObject: ModalConfig) => { 
        if (modalInputObject)
          this.showModal(modalInputObject.component, modalInputObject.componentInputs);
        else
          this.closeModal();
      }
    );
  }

  showModal(component: Type<any>, data: any) {
    let componentFactory: ComponentFactory<any>;
    let componentRef: ComponentRef<any>;

    componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    this.placeholderVcr.clear();
    componentRef = this.placeholderVcr.createComponent(componentFactory);

    if (Object.keys(data).length > 0) {
      this.assignDataToComponentInputs(componentRef, data);
    }

    this.isVisible = true
  }

  closeModal() {
    this.placeholderVcr.clear();
    this.isVisible = false;
  }

  assignDataToComponentInputs(componentRef: ComponentRef<any>, data: any): ComponentRef<any> {
    Object.keys(data).forEach(k => componentRef.instance[k] = data[k]);
    return componentRef;
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/modal.ts